







































import Vue from 'vue';
import { defineComponent, computed } from '@vue/composition-api';

const componentName = 'wok-dialog';

export default defineComponent({
    name: componentName,

    props: {
        kind: { 
            type: String, 
            default: 'alert',
            validator: (v: string) => v == '' || /(alert|simple|confirmation)/.test(v) 
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },

    setup(props, context) {
        const wrapperClasses = computed(() => {
            return {
                'wok--dialog__wrapper': true,
                'wok--dialog--is-loading': props.isLoading,
                [`wok--dialog--${props.kind}`]: props.kind,
            };
        });

        const onRequestHideDialog = () => {
            if (!props.isLoading) {
                context.emit('hide-dialog'); 
            }
        }

        return {
            wrapperClasses,
            onRequestHideDialog
        }
    }
})
